import React, { useState } from 'react';
import '../../App.css';
import '../missionWrapp/missionwrapp.css';
import mPrf from '../../images/time-img1.png';
import { END_URL, IMG_URL } from "../../config.js";

function MissonWrapp({ data }) {
  const [firstAnswer, setFirstAnswer] = useState(null);  // 'yes' or 'no'
  const [secondAnswer, setSecondAnswer] = useState(null); // 'yes' or 'no'
  const [eligibleMessage, setEligibleMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState(''); // 🔹 New state for validation error

  if (!data) return null;

  const handleCheckEligibility = (e) => {
    e.preventDefault(); // Prevent default anchor navigation
    setErrorMessage(''); // Clear previous error messages

    // ✅ Validation: Check if both radio groups are answered
    if (!firstAnswer || !secondAnswer) {
      setEligibleMessage(''); // Clear eligibility message if any
      setErrorMessage('Please select an option for both questions.');
      return; // Stop execution
    }

    // ✅ Both answers selected, proceed with eligibility check
    if (firstAnswer === 'yes' && secondAnswer === 'yes') {
      setEligibleMessage(
        <>
          <p>
            <strong>Result: Likely Eligible. </strong>You shopped during the period and were influenced by promotions.
            We strongly encourage you to register.
          </p>
          <a href="/registerPage" className="register-btn">Register to confirm</a>
        </>
      );
    } else {
      setEligibleMessage(
        <>
          <p>
            <strong>Result: Potentially Eligible.</strong> Even if you are unsure, register for a formal assessment.
          </p>
          <a href="/registerPage" className="register-btn">Register to confirm</a>
        </>
      );
    }
  };

  return (
    <section className="misson-wrapp">
      <div className="container">
        {data.participanttitle && (
          <div dangerouslySetInnerHTML={{ __html: data.participanttitle }}></div>
        )}

        <div className="row elig-row">
          <div className="col-md-6">
            <div className="prcs-col1">
              {data.update1 && (
                <div dangerouslySetInnerHTML={{ __html: data.update1 }}></div>
              )}
            </div>
          </div>

          <div className="col-md-6">
            <div className="elig-col1">
              {data.update2 && (
                <div dangerouslySetInnerHTML={{ __html: data.update2 }}></div>
              )}

              {/* ✅ First Question */}
              <div className="form-group">
                <label>
                  <input
                    type="radio"
                    name="firstGroup"
                    value="yes"
                    checked={firstAnswer === 'yes'}
                    onChange={() => setFirstAnswer('yes')}
                  />
                  Yes
                </label>
                <label>
                  <input
                    type="radio"
                    name="firstGroup"
                    value="no"
                    checked={firstAnswer === 'no'}
                    onChange={() => setFirstAnswer('no')}
                  />
                  No
                </label>
              </div>

              {data.update3 && (
                <div dangerouslySetInnerHTML={{ __html: data.update3 }}></div>
              )}

              {/* ✅ Second Question */}
              <div className="form-group">
                <label>
                  <input
                    type="radio"
                    name="secondGroup"
                    value="yes"
                    checked={secondAnswer === 'yes'}
                    onChange={() => setSecondAnswer('yes')}
                  />
                  Yes
                </label>
                <label>
                  <input
                    type="radio"
                    name="secondGroup"
                    value="no"
                    checked={secondAnswer === 'no'}
                    onChange={() => setSecondAnswer('no')}
                  />
                  No
                </label>
              </div>

              {/* ✅ Button */}
              <a href="" className="elg-btn" onClick={handleCheckEligibility}>
                {data.ongoingtitle4 || 'See Quick Results'}
              </a>

              {/* 🔹 Show validation error (if any) */}
              {errorMessage && (
                <div className="error-message" style={{ color: 'red', marginTop: '10px' }}>
                  {errorMessage}
                </div>
              )}

              {/* 🔹 Show eligibility result */}
              {eligibleMessage && (
                <div className="eligibility-message">{eligibleMessage}</div>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default MissonWrapp;
